import { UrlSegment } from '@angular/router';

export const bySalonIdUrlMatcher = (urlSegments: UrlSegment[]) => {
  const salonIdGuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/gm;
  if (urlSegments.length >= 1 && urlSegments[0].path.match(salonIdGuidRegex)) {
    return {
      consumed: [new UrlSegment(urlSegments[0].path, {})],
      posParams: {
        simpleFlowSalonId: new UrlSegment(urlSegments[0].path, {})
      }
    };
  }
  return null;
}

export const byCityAndAliasUrlMatcher = (urlSegments: UrlSegment[]) => {
  if (urlSegments.length >= 2) {
    return {
      consumed: [
        new UrlSegment(urlSegments[0].path, {}),
        new UrlSegment(urlSegments[1].path, {})
      ],
      posParams: {
        cityName: new UrlSegment(urlSegments[0].path, {}),
        salonNameAlias: new UrlSegment(urlSegments[1].path, {})
      }
    };
  }
  return null;
}
